import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import queryString from 'query-string';
import _ from 'lodash';
import SimpleReactValidator from 'simple-react-validator';

import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { history } from '../../../shared/configure-store';
import Api from '../../../libraries/api';
import AuthHelper from '../../../libraries/auth-helper';
import TablePaginationActions from '../../presentational/table-pagination-actions';


require('dotenv').config();

class RegionalSetupAssign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingButton: false,
            errors: {},
            regional_codes: [],
            corporate_customers: [],
            id: '',
            regional_name: '',
            regional_code: '',
            user_id: [],
            rows: [],
            total: 0,
            perPage: 10,
            currentPage: 0,
            isManage: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.validator = new SimpleReactValidator({
            messages: {
                required: 'Field ini wajib diisi',
            },
        });
    }

    componentDidMount() {
        document.title = 'Gudangemas - Ubah Regional Setup';
        let profile = AuthHelper.getProfile();

        if (profile['map-menu']) {
            let roles = profile['map-menu'].map((o) => ({
                id: o.id,
                name: o.menu.name,
                isManage: o.isManage,
            }));




            // TODO: FIX PERMISSION TO REGIONAL SETUP
            let all = roles.filter(item => item.name === 'Daftar Produk');
            this.setState({ isManage: all.length > 0 ? all[0].isManage : false });



        }

        this.fetchData();
        this.fetchRegionalCodes();
    }

    fetchData = () => {
        const queryParams = queryString.parse(this.props.location.search);
        const regionalCode = queryParams.regional_code ? decodeURIComponent(queryParams.regional_code) : '';
        const params = { page: 0, size: 1000, regional_code: regionalCode };
    
        Api.post('/region/setup/find', params)
            .then((resp) => {
                if (resp.status === 200) {
                    const data = resp.data.content[0];
                    this.setState({
                        id: data.id,
                        regional_name: data.regional_name || '',
                        regional_code: data.regional_code || '',
                        user_id: data.user_id || [],
                    }, () => {
                        this.fetchCorporateCustomers();
                    });
                }
            })
            .catch(() => {
                toast.error('Gagal mengambil data regional setup');
            });
    };

    fetchRegionalCodes = () => {
        Api.get('/region/master').then(resp => {
            if (resp.data) {
                let all = [];
                _.forEach(resp.data, (v, k) => all.push(v));
                this.setState({ regional_codes: all, loading: false });
            }
        });
    };

    fetchCorporateCustomers = () => {
        const params = { page: 0, size: 1000, 'type-of-customer': 'CORPORATE' };
    
        Api.post('/customer/get-all', params)
            .then((resp) => {
                if (resp.data && resp.data.customers) {
                    const corporateCustomers = resp.data.customers.map((c) => ({
                        id: c['id-customer'],
                        companyName: c.companyName,
                    }));
    
                    const selectedUsers = corporateCustomers.filter((customer) => this.state.user_id === customer.id);
    
                    this.setState({
                        corporate_customers: corporateCustomers,
                        user_id: selectedUsers,
                    });
                }
            })
            .catch((err) => console.log(err));
    };

    handleChange(e, prop) {
        this.setState({ [prop]: e.target.value });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (!this.validator.allValid()) {
            this.validator.showMessages();
            return;
        }

        this.setState({ loadingButton: true });

        const params = {
            id: this.state.id,
            regional_name: this.state.regional_name,
            regional_code: this.state.regional_code,
            user_id: this.state.user_id.map(user => user.id),
        };

        Api.put('/region/setup', params)
            .then(() => {
                toast.success('Regional setup berhasil diubah');
                history.push('/regional-setup');
            })
            .catch(() => {
                toast.error('Gagal memperbarui regional setup');
                this.setState({ loadingButton: false });
            });
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Assign Regional Setup</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/regional-setup">Regional Setup</Link></li>
                            <li className="breadcrumb-item active">Assign</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12">
                    <div className="table-wrapper pb-1">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className="mb-0">Assign Regional Setup</h2>
                            </div>
                            <div className="col-6 text-right">
                                {this.state.isManage && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => this.handleGo('/regional-setup/add')}
                                    >
                                        <i className="fas fa-plus mr-2"></i>
                                        Add User (Corporate)
                                    </Button>
                                )}
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-between content-filter">
                            <div className="col-md-6 col-lg-4 mb-2 mb-md-0">
                                <TextField
                                    id="input-with-icon-textfield"
                                    variant="outlined"
                                    className="search-field"
                                    onChange={(e) => this.handleChange(e, 'searchBy')}
                                    onKeyDown={this.handleKeyDown}
                                    onBlur={this.handleSearch}
                                    placeholder="Search here"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton aria-label="Search click" onClick={this.handleSearch}><i className="fas fa-search"></i></IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="table-list row">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="clickable" onClick={() => this.handleSort('regional_name')}>
                                            Nama Komunitas
                                            {this.state.orderBy === 'regional_name' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('regional_code')}>
                                            Kode Regional
                                            {this.state.orderBy === 'regional_code' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.loading ? (
                                        <TableRow>
                                            <TableCell colSpan={3} align="center" className="py-5"><CircularProgress color="primary" /></TableCell>
                                        </TableRow>
                                    ) : this.state.rows.length === 0 ? (
                                        <TableRow style={{ height: 33 * this.state.perPage }}>
                                            <TableCell colSpan={3} style={{ textAlign: 'center' }}>Data Regional Setup kosong</TableCell>
                                        </TableRow>
                                    ) : (
                                        this.state.rows.map((row) => (
                                            <TableRow key={row.id}>
                                                <TableCell>{row.regional_name}</TableCell>
                                                <TableCell>{row.regional_code}</TableCell>
                                                <TableCell className="action-menu">
                                                    <button className="btn-icon">
                                                        <i className="fas fa-ellipsis-v"></i>
                                                    </button>
                                                    <div className="action-wrap">
                                                        <button className="btn-icon" onClick={() => this.handleOpen(row)}><i className="fas fa-trash-alt"></i> Hapus</button>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50]}
                            component="div"
                            count={this.state.total}
                            rowsPerPage={this.state.perPage}
                            page={this.state.currentPage}
                            backIconButtonProps={{ 'aria-label': 'previous page' }}
                            nextIconButtonProps={{ 'aria-label': 'next page' }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </div>
                </div>
                <Dialog
                    maxWidth="sm"
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">KONFIRMASI</DialogTitle>
                    <DialogContent>
                        <p>Apakah anda yakin akan menghapus <strong>{this.state.currDelete}</strong>?</p>
                    </DialogContent>
                    <DialogActions>
                        <button className="btn btn-blue-trans" onClick={this.handleClose}>Batal</button>
                        <button className="btn btn-blue" onClick={this.handleDelete}>Hapus</button>
                    </DialogActions>
                </Dialog>
                <ToastContainer />
            </div>
        );
    }
}

export default RegionalSetupAssign;